// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-back-to-system-overview',
  templateUrl: './backToSystemOverview.component.html',
  styleUrls: ['./backToSystemOverview.component.scss'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BackToSystemOverviewComponent {
  @Input({ required: true }) relativeUrl = '../';

  constructor(protected router: Router, protected route: ActivatedRoute) {}
}
